var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgreementDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 42,
    rx: 21,
    fill: "#ECFDF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_10160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3333 20.2333V21C31.3323 22.797 30.7504 24.5455 29.6744 25.9848C28.5984 27.4241 27.086 28.477 25.3628 28.9866C23.6395 29.4961 21.7977 29.4349 20.112 28.8121C18.4264 28.1894 16.9872 27.0384 16.0091 25.5309C15.031 24.0233 14.5665 22.24 14.6847 20.4469C14.8029 18.6538 15.4976 16.9469 16.6652 15.5809C17.8328 14.2148 19.4106 13.2628 21.1635 12.8668C22.9163 12.4707 24.7502 12.6519 26.3916 13.3833M31.3333 14.3333L23 22.675L20.5 20.175",
    stroke: "#12B76A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_10160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreementDone);
export default __webpack_public_path__ + "static/media/agreementDone.a30cbea390893605b6269961598989fc.svg";
export { ForwardRef as ReactComponent };